<template>
  <div>
    <div class="page-title mb-30">Pods</div>
    <div class="page-content" v-loading="loading">
      <div class="manage-filter-bar">
        <el-input
          v-model="filter"
          size="small"
          clearable
          prefix-icon="el-icon-search"
          class="manage-filter-input"
          placeholder="filter by pod mac"
        ></el-input>
        <el-button size="small" icon="el-icon-refresh" @click="getData"
          >Refresh</el-button
        >
      </div>
      <el-table border size="small" :data="displayData">
        <el-table-column
          label="Pod"
          prop="PodMac"
          fixed="left"
        ></el-table-column>
        <el-table-column label="Room" prop="RoomNumber"></el-table-column>
        <el-table-column label="Bed" prop="BedNumber"></el-table-column>
        <el-table-column
          label="Organisation"
          prop="Organisation"
        ></el-table-column>
        <el-table-column label="Action" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="danger"
              plain
              class="mini-btn min-w-80"
              @click="unlinkPod(scope.row)"
              >Unlink</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/ReportApiService.js'
export default {
  data() {
    return {
      loading: false,
      data: [],
      displayData: [],
      filter: '',
      timer: ''
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.filterPods, 500)
    }
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.GetPodList()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data
            this.displayData = this.data
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    filterPods() {
      this.displayData = this.data.filter(item => {
        return item.PodMac.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
      })
    },
    unlinkPod(item) {
      this.$confirm(
        'Please keep in mind that unlink pods is permanent.',
        `You're about to unlink ${item.PodMac}`,
        {
          confirmButtonText: 'UNLINK',
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'delete-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          this.handleUnlink(item.id)
        })
        .catch(() => {})
    },
    handleUnlink(id) {
      ApiService.UnlinkPod(id)
        .then(response => {
          if (response.data.success) {
            this.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Unlink Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Unlink Failed'
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.manage-filter-bar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  .el-button {
    flex: none;
  }
}

.manage-filter-input {
  flex: none;
  width: 260px;

  /deep/ .el-input__inner {
    width: 260px;
  }
}
</style>
